module.exports = __webpack_public_path__ + "static/media/instagram-stories-sea.6e227128.mp4";